<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" label-width="68px" size="mini">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="委托编号" prop="entrustNum">
            <el-input v-model="queryParams.entrustNum" placeholder="请输入委托编号" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="识别码" prop="OIDNO">
            <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检测区域" prop="testArea">
            <el-select v-model="queryParams.testArea" placeholder="请选择检测区域" clearable style="width: 100%" @change="handleQuery">
              <el-option label="福州区域" value="福州区域" />
              <el-option label="厦门区域" value="厦门区域" />
              <el-option label="泉州区域" value="泉州区域" />
              <el-option label="漳州区域" value="漳州区域" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: center; margin-bottom: 10px;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </div>
    </el-form>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="testDataList" border>
      <el-table-column label="委托编号" align="left" prop="entrustNum" width="240" show-overflow-tooltip />
      <el-table-column label="电梯识别码" align="left" prop="OIDNO" width="180" show-overflow-tooltip />
      <el-table-column label="使用单位名称" align="left" prop="USE_UNT_NAME" width="260" :show-overflow-tooltip="true" />
      <el-table-column label="现场联系人" align="left" prop="siteContact" width="120" show-overflow-tooltip />
      <el-table-column label="联系方式" align="left" prop="contactPhone" width="180" show-overflow-tooltip />
      <el-table-column label="设备使用地点" align="left" prop="EQP_USE_ADDR" width="300" :show-overflow-tooltip="true" />
      <el-table-column label="设备名称" align="left" prop="EQP_NAME" width="120" show-overflow-tooltip />
      <el-table-column label="设备类别" align="left" prop="EQP_SORT_NAME" width="120" show-overflow-tooltip />
      <el-table-column label="上次检测日期" align="left" prop="lastTestDate" width="120" show-overflow-tooltip />
      <el-table-column label="操作" align="left" class-name="small-padding fixed-width" fixed="right" width="100">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)"
            >编辑</el-button
          > -->
          <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleCheck="handleCheck(scope.row)" @handleBack="handleBack(scope.row)" />
          <!-- <el-button size="mini" type="text" icon="el-icon-check" @click="handleCheck(scope.row)">
            校核
          </el-button>
          <el-button size="mini" type="text" icon="el-icon-back" @click="handleBack(scope.row)">
            退回
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination v-show="total > 0" :total="total" :page-size="queryParams.pageSize" :current-page="queryParams.currPage" @current-change="getList" />

    <!-- 编辑弹窗 -->
    <el-dialog :title="'委托编号：' + currentEntrustmentCode" :visible.sync="editDialogVisible" width="900px" append-to-body destroy-on-close>
      <div class="edit-container">
        <div class="image-container">
          <img :src="require('./img.png')" alt="检测数据图片" class="preview-image" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleSave" type="primary" size="mini">保存</el-button>
        <el-button @click="handleComplete" type="success" size="mini">完成</el-button>
        <el-button @click="handlePreview" type="info" size="mini">预览</el-button>
      </div>
    </el-dialog>

    <!-- 文件预览弹窗 -->
    <el-dialog title="文件预览" :visible.sync="previewDialogVisible" width="80%" append-to-body destroy-on-close fullscreen>
      <div class="preview-container">
        <iframe :src="previewUrl" class="preview-frame"></iframe>
      </div>
    </el-dialog>

    <!-- 操作人员选择弹窗 -->
    <el-dialog :title="operatorDialog.title" :visible.sync="operatorDialog.visible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="operatorForm" :model="operatorForm" label-width="80px">
        <el-form-item label="操作人员">
          <el-select v-model="operatorForm.employeePid" placeholder="请选择操作人员" style="width: 100%" clearable>
            <el-option v-for="item in employeeList" :key="item.employeePid" :label="item.employeeName" :value="item.employeePid" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operatorDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleOperatorConfirm" :loading="operatorDialog.loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { testDataOperator, queryTestDataCheckList, queryEmployeeDropdown } from '@/api/contract/contract';
export default {
  name: 'TestData',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 遮罩层
      loading: false,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 测试数据表格数据
      testDataList: [],
      // 操作人员弹窗
      operatorDialog: {
        visible: false,
        title: '',
        loading: false,
        optType: '', // Audit, Back
        currentRow: null
      },
      // 操作人员表单
      operatorForm: {
        employeePid: ''
      },
      // 操作人员列表
      employeeList: [],
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        entrustNum: undefined,
        OIDNO: undefined,
        testArea: undefined
      },
      // 编辑弹窗相关
      editDialogVisible: false,
      currentEntrustmentCode: '',
      // 预览弹窗相关
      previewDialogVisible: false,
      previewUrl: '@public\documents\有机房货梯原始记录(1).docx'
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 获取列表数据 */
    getList () {
      this.loading = true
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      // 添加搜索条件
      if (this.queryParams.entrustNum) {
        params.entrustNum = this.queryParams.entrustNum
      }
      if (this.queryParams.OIDNO) {
        params.OIDNO = this.queryParams.OIDNO
      }
      if (this.queryParams.testArea) {
        params.testArea = this.queryParams.testArea
      }

      queryTestDataCheckList(params).then(response => {
        this.testDataList = response.additionalData.records || []
        this.total = response.total || 0
        this.loading = false
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
        this.loading = false
      })
    },
    /** 获取操作人员列表 */
    getEmployeeList (sginType) {
      const params = {
        configReportPid: this.operatorDialog.currentRow.configReportPid || ''
      }
      if (sginType) {
        params.sginType = sginType
      }

      queryEmployeeDropdown(params).then(response => {
        this.employeeList = response.additionalData || []
      }).catch(error => {
        console.error('获取操作人员列表失败:', error)
        this.$message.error('获取操作人员列表失败')
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams.currPage = 1
      this.queryParams.entrustNum = undefined
      this.queryParams.OIDNO = undefined
      this.queryParams.testArea = undefined
      this.$refs.queryForm.resetFields()
      this.getList()
    },
    /** 编辑按钮操作 */
    handleEdit (row) {
      this.currentEntrustmentCode = row.entrustNum
      this.editDialogVisible = true
    },
    /** 保存按钮操作 */
    handleSave () {
      this.$message.success('保存成功')
    },
    /** 完成按钮操作 */
    handleComplete () {
      this.$message.success('操作已完成')
      this.editDialogVisible = false
    },
    /** 预览按钮操作 */
    handlePreview () {
      // 设置预览文件路径
      // this.previewUrl = process.env.BASE_URL + 'static/有机房货梯原始记录(1).docx'
      this.previewDialogVisible = true
    },
    /** 校核按钮操作 */
    handleCheck (row) {
      this.showOperatorDialog('校核', 'Check', row, 'Audit')
    },
    /** 退回按钮操作 */
    handleBack (row) {
      this.showOperatorDialog('退回', 'Back', row)
    },
    /** 显示操作人员选择弹窗 */
    showOperatorDialog (title, optType, row, sginType) {
      this.operatorDialog.title = `选择${title}人员`
      this.operatorDialog.optType = optType
      this.operatorDialog.currentRow = row
      this.operatorDialog.visible = true

      // 清空表单
      this.operatorForm.employeePid = ''

      // 获取操作人员列表
      if (sginType) {
        this.getEmployeeList(sginType)
      } else {
        // 退回操作不需要传sginType
        this.getEmployeeList()
      }
    },
    /** 操作人员确认 */
    handleOperatorConfirm () {
      // 退回操作不需要选择人员
      if (this.operatorDialog.optType !== 'Back' && !this.operatorForm.employeePid) {
        this.$message.warning('请选择操作人员')
        return
      }

      this.operatorDialog.loading = true

      const params = {
        nextEmployeePid: this.operatorForm.employeePid || '',
        id: this.operatorDialog.currentRow.id || '', // 退回操作可以为空
        entrustNum: this.operatorDialog.currentRow.entrustNum,
        optType: this.operatorDialog.optType
      }

      testDataOperator(params).then(response => {
        this.operatorDialog.loading = false
        this.operatorDialog.visible = false

        // 成功提示
        const optTypeText = {
          'Audit': '校核',
          'Back': '退回'
        }
        this.$message.success(`${optTypeText[this.operatorDialog.optType]}操作成功`)

        // 刷新列表
        this.getList()

      }).catch(error => {
        this.operatorDialog.loading = false
        console.error('操作失败:', error)

        // 显示失败原因
        const errorMessage = error.response?.data?.message || error.message || '操作失败'
        this.$message.error(errorMessage)
      })
    }
  }
}
</script>

<style scoped>
.edit-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.image-container {
  width: 100%;
  text-align: center;
}
.preview-image {
  max-width: 100%;
  max-height: 600px;
}
.preview-container {
  width: 100%;
  height: 80vh;
}
.preview-frame {
  width: 100%;
  height: 100%;
  border: none;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
